<template>
  <div class="right">
    <div class="qzgl_moudle">
      <section class="qzgl_title" id="qzgl_title">
        <div
          v-for="(item, index) in headerList"
          :data-value="item.value"
          :key="index"
          @click="reds($event, index)"
          :class="{
            title_card_active: activeIndex == index,
          }"
          class="title_card"
        >
          {{ item.name }}
        </div>
      </section>
      <section class="qzgl_content animated fadeIn">
        <img
          src="@/assets/images/empty.png"
          style="display: block; margin: 0 auto"
          v-if="signList.length == 0"
        />
        <div class="wdsc_items" v-for="(item, index) in signList" :key="index">
          <div class="wdsc_item_title">
            <div class="wdsc_item_title_content_left">
              <div
                class="wdsc_item_title_content_left_content1_m"
                onclick="tz_zwxq(1000100863115,1010575,0)"
              >
                {{ item.companyName }}
              </div>
              <div class="wdsc_item_title_content_left_content1_x">
                <div class="wdsc_item_title_content_left_content1_xz">
                  {{ item.postName }}
                </div>
                <div class="wdsc_item_title_content_left_content1_ms">
                  {{ item.postNum }}
                </div>
              </div>
              <div
                v-if="item.recruitNotice && item.recruitNotice.prompt"
                class="wdsc_item_title_content_left_content1_x"
              >
                <div class="wdsc_item_title_content_left_content1_xz">
                  {{ item.recruitNotice.prompt }}
                </div>
              </div>
              <!-- && (item.writeScore || item.interviewScore) -->
              <div
                v-if="
                  activeIndex > 1 &&
                  item.recruitNotice &&
                  item.recruitNotice.openScore == 1
                "
                class="wdsc_item_title_content_left_content1_x"
              >
                <div
                  v-if="activeIndex == 2 && (item.writeScore|| item.writeScore==0 )"
                  class="wdsc_item_title_content_left_content1_xz"
                  style="color: #333; margin-right: 5px"
                >
                  笔试成绩:
                </div>
                <div
                  v-if="activeIndex == 3 && (item.interviewScore ||item.interviewScore==0 )"
                  class="wdsc_item_title_content_left_content1_xz"
                  style="color: #333; margin-right: 5px"
                >
                  面试成绩:
                </div>
                <div
                  v-if="activeIndex == 2 && (item.writeScore|| item.writeScore==0 )"
                  class="wdsc_item_title_content_left_content1_ms"
                  style="color: #333; font-size: 20px"
                >
                  {{ item.writeScore }}
                </div>
                <div
                  v-if="activeIndex == 3 && (item.interviewScore ||item.interviewScore==0 )"
                  class="wdsc_item_title_content_left_content1_ms"
                  style="color: #333; font-size: 20px"
                >
                  {{ item.interviewScore }}
                </div>
                <div
                  v-if="
                    activeIndex == 2 &&
                    item.signScore &&
                    (item.signScore.writeSortPost || item.signScore.writeSortPost==0 )
                  "
                  style="display: flex"
                >
                  <div
                    class="wdsc_item_title_content_left_content1_xz"
                    style="color: #333; margin-right: 5px; margin-left: 10px"
                  >
                    岗位笔试排名:
                  </div>
                  <div
                    class="wdsc_item_title_content_left_content1_ms"
                    style="color: #333; font-size: 20px"
                  >
                    {{ item.signScore.writeSortPost }}
                  </div>
                </div>
                <div
                  v-if="
                    activeIndex == 3 &&
                    item.signScore &&
                    (item.signScore.interviewSortPost || item.signScore.interviewSortPost==0)
                  "
                  style="display: flex"
                >
                  <div
                    class="wdsc_item_title_content_left_content1_xz"
                    style="color: #333; margin-right: 5px; margin-left: 10px"
                  >
                    岗位面试排名:
                  </div>
                  <div
                    class="wdsc_item_title_content_left_content1_ms"
                    style="color: #333; font-size: 20px"
                  >
                    {{ item.signScore.interviewSortPost }}
                  </div>
                </div>
              </div>
              <div
                v-if="
                  activeIndex == 3 &&
                  item.totalScore &&
                  item.recruitNotice &&
                  item.recruitNotice.openScore == 1
                "
                class="wdsc_item_title_content_left_content1_x"
              >
                <div
                  class="wdsc_item_title_content_left_content1_xz"
                  style="color: #333; margin-right: 5px"
                >
                  综合成绩:
                </div>
                <div
                  class="wdsc_item_title_content_left_content1_ms"
                  style="color: #333; font-size: 20px"
                >
                  {{ item.totalScore }}
                </div>
              </div>
            </div>
            <div class="wdsc_item_title_content_right">
              <div class="wdsc_item_title_content_right_content1">
                <div
                  class="wdsc_item_title_content_right_content1_m"
                  style="cursor: pointer"
                  @click="showRecruitDetail(item)"
                >
                  {{ item.recruitName }}
                </div>
                <div
                  v-if="
                    activeIndex <= 1 ||
                    (activeIndex > 1 &&
                      item.recruitNotice &&
                      item.recruitNotice.openScore == 1)
                  "
                  class="wdsc_item_title_content_right_content1_d"
                  style="float: right"
                  :class="
                    item.auditStatus && item.auditStatus.indexOf('未通过') > 0
                      ? 'jujue'
                      : 'tongguo'
                  "
                >
                  {{ item.auditStatus }}
                  <span
                    v-if="item.recruitNotice && item.status == 2"
                    :class="item.payStatus ? 'tongguo' : 'jujue'"
                  >
                    {{
                      item.payStatus == 2
                        ? "免费"
                        : item.payStatus == 1
                        ? "已缴费"
                        : "未缴费"
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="wdsc_item_bottom">
            <div
              class="wdsc_item_bottom_qx"
              v-if="item.status == 0"
              @click="cancleSign(item)"
            >
              取消报名
            </div>
            <div
              class="wdsc_item_bottom_td"
              style="margin-right: 20px"
              v-if="item.status == 2 && item.payStatus == 0"
              @click="showPayDetail(item)"
            >
              去缴费
            </div>
            <div
              class="wdsc_item_bottom_td"
              style="margin-right: 20px"
              v-if="item.examineeInformation && item.examineeInformation.isOpen"
              @click="printTicket(item.examineeInformation)"
            >
              <!--              -->
              打印准考证
            </div>
            <div
              class="wdsc_item_bottom_td"
              style="margin-right: 20px"
              v-if="item.status == 3"
              @click="showSignDetail(item)"
            >
              修改
            </div>
            <div class="wdsc_item_bottom_td" @click="showSignDetail(item)">
              查看详情
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="fenye" v-if="total > 0">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next, jumper"
        :total="total"
        :page-size="search.pageSize"
        :current-page.sync="search.pageNum"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
    <sign-up
      ref="signUp"
      @getMySign="getMySign"
      :recruitId="recruitId"
      :showSignUp.sync="showSignUp"
    ></sign-up>
    <!-- <post-apply
      ref="postApply"
      @getMySign="getMySign"
        :recruitId="recruitId"
      :showPostApply.sync="showPostApply"
    ></post-apply> -->
    <sign-pay
      ref="signPay"
      @getMySign="getMySign"
      :showSignPay.sync="showSignPay"
    ></sign-pay>

    <!--打印-->
    <el-dialog
      title="打印准考证:温馨提示缩放60%打印效果更好"
      width="800px"
      :visible.sync="printVisible"
    >
      <!-- startprint -->
      <div class="box">
        <div
          id="printMe"
          class="printMe"
          v-if="printVisible"
          ref="printMe"
          v-html="ticketInfo"
        ></div>
      </div>
      <!-- startprint -->
      <div style="text-align: right">
        <el-button v-print="printObj" type="primary" icon="el-icon-printer"
          >直接打印
        </el-button>
        <el-button @click="printVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!--打印pdf-->
    <el-dialog width="800px" :visible.sync="printPdfVisible" append-to-body>
      <!-- startprint -->
      <div class="pdf-box">
        <!-- <div v-for="i in pdfTotalPages" class="pdf-num-div" :key="i">
          <pdf
            :key="i"
            :src="src"
            :page="i"
            style="display: block; width: 100%"
          ></pdf>
        </div> -->
        <pdf
          style="display: block; width: 100%"
          ref="pdfPrint"
          :src="src"
        ></pdf>
      </div>
      <!-- startprint -->
      <div style="text-align: right">
        <el-button @click="printPdfObj" type="primary" icon="el-icon-printer"
          >直接打印
        </el-button>
        <!-- <el-button @click="downloadFile" type="primary" icon="el-icon-download"
          >下载</el-button
        > -->
        <el-button @click="printPdfVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%">
      <span>{{ ticketShowInfo.message }}</span>

      <img
        style="width: 100%; height: 100%; margin-top: 10px"
        @click="showViewer = true"
        v-if="ticketShowInfo.showImg"
        src="@/assets/newImg/546.jpg"
      />
      <div style="text-align: center" v-if="ticketShowInfo.showImg">
        考场示意图
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doPrintDialog">确 定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer
      style="z-index: 9999"
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
  </div>
</template>

<script>
import SignUp from "@/components/signUp.vue";
import SignPay from "@/components/signPay.vue";
import PostApply from "@/components/postApply";
import pdf from "vue-pdf-cs";
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";

export default {
  components: {
    PostApply,
    SignUp,
    SignPay,
    pdf,
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      total: 0,
      search: {
        pageNum: 1,
        pageSize: 3,
        statusArr: "0",
        sendResume: 0,
      },
      activeIndex: 0,
      signList: [
        {
          writeScore: 0,
        },
      ],
      headerList: [
        {
          name: "待提交",
          value: "0",
        },
        {
          name: "初审结果",
          value: "cs",
        },
        // {
        //   name: "待审核",
        //   value: "1",
        // },
        // {
        //   name: "审核通过",
        //   value: "2",
        // },
        // {
        //   name: "审核未通过",
        //   value: "3",
        // },
        {
          name: "笔试结果",
          value: "bs",
          writteStatus: "2",
        },
        {
          name: "面试结果",
          value: "ms",
          interviewStatus: "2",
        },
      ],
      recruitId: "",
      signupId: 0,
      showSignUp: false,
      showPostApply: false,
      showSignPay: false,

      printVisible: false,

      ticketInfo: "",
      ticketId: "",
      printObj: {
        id: "printMe",
        popTitle: "打印",
        clickMounted: (e) => {
          // this.printVisible = false
          this.updateTicketStatus(2);
        },
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      printPdfVisible: false,
      src: "",
      pdfTotalPages: 0,
      showViewer: false,
      dialogVisible: false,
      currentTicket: {},
      ticketShowInfo: {},
      imgList: ["https://www.sjzhrgroup.com/statics/2024/12/26/546.jpg"],
    };
  },
  activated() {
    this.getMySign();
  },
  watch: {
    printVisible: function (val) {
      console.log(val, "val");
      if (!val) {
        // this.updateTicketStatus(2);
      }
    },
  },
  methods: {
    showRecruitDetail(item) {
      if (item.recruitNotice && item.recruitNotice.id) {
        this.$router.push({
          path: "/recruitDetail",
          query: {
            id: item.recruitNotice.id,
          },
        });
      }
    },
    reds(e, index) {
      let _this = this;
      _this.activeIndex = index;
      _this.signList = [];
      let value = e.target.dataset.value;
      if (value === "ms") {
        _this.search.interviewStatus = 2;
        delete _this.search.statusArr;
        delete _this.search.writtenExaminationStatus;
      } else if (value === "bs") {
        _this.search.writtenExaminationStatus = 2;
        delete _this.search.statusArr;
        delete _this.search.interviewStatus;
      } else if (value === "cs") {
        _this.search.statusArr = "1,2,3";
        delete _this.search.writtenExaminationStatus;
        delete _this.search.interviewStatus;
      } else {
        _this.search.statusArr = "0";
        delete _this.search.writtenExaminationStatus;
        delete _this.search.interviewStatus;
      }

      _this.getMySign();
    },
    handleCurrentChange(val) {
      console.log(`000每页 ${val} 条`);
      let _this = this;
      _this.search.pageNum = val;
      _this.getMySign();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    getMySign() {
      let _this = this;
      console.log("getMySign", _this.search);
      _this.$api.sign
        .getSignList(_this.search)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.signList = res.rows;

            _this.signList.forEach((item) => {
              switch (item.status) {
                case 0:
                  item.auditStatus = "待提交";
                  break;
                case 1:
                  item.auditStatus = "待审核";
                  break;
                case 2:
                  if (_this.activeIndex == 1) {
                    item.auditStatus = "初审通过";
                  }
                  if (_this.activeIndex == 2) {
                    // item.auditStatus = "笔试通过";
                    if (item.writtenExaminationReasons) {
                      item.auditStatus =
                        "笔试结果:" + item.writtenExaminationReasons;
                    } else {
                      item.auditStatus = "";
                    }
                  }
                  if (_this.activeIndex == 3) {
                    // item.auditStatus = "面试通过";
                    if (item.interviewReasons) {
                      item.auditStatus = "面试结果:" + item.interviewReasons;
                    } else {
                      item.auditStatus = "";
                    }
                  }
                  // if (_this.activeIndex == 3) {
                  //   if (item.writtenExaminationStatus == 3) {
                  //     item.auditStatus =
                  //       "笔试结果:" + item.writtenExaminationReasons;
                  //   } else if (item.interviewStatus == 3) {
                  //     item.auditStatus = "面试结果:" + item.interviewReasons;
                  //   }
                  // }
                  break;
                case 3:
                  item.auditStatus = "初审未通过:" + item.auditReasons;
                  break;
                default:
                  item.auditStatus = "";
              }
            });
            _this.total = Number(res.total);
          }
        })
        .catch(() => {});
    },
    cancleSign(item) {
      let _this = this;
      let param = {
        id: item.id,
      };
      _this.$layer.confirm(
        "确定要取消此报名吗?",
        {
          btn: ["确定", "取消"], // 按钮
        },
        function (index) {
          _this.$api.sign
            .cancelSignInfo(param)
            .then((res) => {
              if (res.code == _this.$commons.RespCode.success) {
                _this.$layer.alert("操作成功!");
                _this.getMySign();
              }
            })
            .catch(() => {});
          _this.$layer.close(index);
        },
        function (index) {
          _this.$layer.close(index);
        }
      );
    },
    showSignDetail(item) {
      console.log("item", item);
      let _this = this;
      _this.recruitId = String(item.recruitId);
      if (item.recruitId == 238) {
        _this.$layer.confirm(
          "石家庄市市属国有企业2024年春季面向社会公开招聘《笔试准考证》打印时间调整至6月5日12:00，请考生使用电脑端打印准考证。",
          {
            btn: ["确定", "取消"], // 按钮
          },
          function (index) {
            _this.$layer.close(index);
            _this.showSignUp = true;
            _this.$refs.signUp.showSignUp = true;
            _this.$refs.signUp.getSignUpById(item.id);
          },
          function (index) {
            _this.$layer.close(index);
            _this.showSignUp = true;
            _this.$refs.signUp.showSignUp = true;
            _this.$refs.signUp.getSignUpById(item.id);
          }
        );
      } else {
        _this.showSignUp = true;
        _this.$refs.signUp.showSignUp = true;
        _this.$refs.signUp.getSignUpById(item.id);
      }

      // _this.$refs.signUp.getPostList();
    },
    // 更换个人信息登记表界面
    // showSignDetail(item) {
    //   let _this = this;
    //   _this.recruitId = String(item.recruitId);
    //   if (item.recruitId == 238) {
    //     _this.$layer.confirm(
    //       "石家庄市市属国有企业2024年春季面向社会公开招聘《笔试准考证》打印时间调整至6月5日12:00，请考生使用电脑端打印准考证。",
    //       {
    //         btn: ["确定", "取消"], // 按钮
    //       },
    //       function (index) {
    //         _this.$layer.close(index);
    //         _this.showPostApply = true;
    //         _this.$refs.postApply.showPostApply = true;
    //         _this.$refs.postApply.getSignUpById(item.id);
    //       },
    //       function (index) {
    //         _this.$layer.close(index);
    //         _this.showPostApply = true;
    //         _this.$refs.postApply.showPostApply = true;
    //         _this.$refs.postApply.getSignUpById(item.id);
    //       }
    //     );
    //   } else {
    //     _this.showPostApply = true;
    //     _this.$refs.postApply.showPostApply = true;
    //     _this.$refs.postApply.getSignUpById(item.id);
    //   }

    // _this.$refs.postApply.getPostList();
    // },
    /*showPayDetailOld(item) {
      // console.log("去支付", item);
      let _this = this;
      let endPayParam = {
        enrollId: item.id,
        recruitNoticeId: item.recruitId,
      };
      _this.$api.sign.endPay(endPayParam).then((res) => {
        if (res.code == _this.$commons.RespCode.success) {
          _this.$layer.confirm(
            // "请认真核对报名信息，缴费一旦成功，不予退还。是否进行缴费？",
            "缴纳费用为报名费，请认真核对报名信息，缴费一旦成功，不予退费。是否进行缴费？",
            {
              btn: ["是", "否"], // 按钮
            },
            function (index) {
              _this.showSignPay = true;
              _this.$refs.signPay.showSignPay = true;
              _this.$refs.signPay.getSignUpById(item.id);
              _this.signupInfo = {};
              _this.$layer.close(index);
            },
            function (index) {
              _this.showSignPay = false;
              _this.$layer.close(index);
            }
          );
        } else {
          _this.$layer.alert(res.msg);
          return;
        }
      });
    },*/
    showPayDetail(item) {
      console.log("去支付", item);
      let _this = this;
      let endPayParam = {
        enrollId: item.id,
        recruitNoticeId: item.recruitId,
      };
      _this.$layer.confirm(
        "请认真核对报名信息，本次缴纳费用为报名费，缴费成功不予退还。请确认是否进行缴费？?",
        {
          btn: ["确定", "取消"], // 按钮
        },
        function (index) {
          _this.$api.sign
            .endPay(endPayParam)
            .then((res) => {
              if (res.code == _this.$commons.RespCode.success) {
                let lybl = _this.$router.resolve({
                  path: "/pay",
                  query: {
                    id: item.recruitId,
                    enrollId: item.id,
                  },
                });

                window.open(lybl.href, "_blank");
              } else {
                _this.$layer.alert(res.msg);
              }
            })
            .catch(() => {});
          _this.$layer.close(index);
        },
        function (index) {
          _this.$layer.close(index);
        }
      );
    },
    doPrintDialog() {
      let _this = this;
      _this.ticketId = _this.currentTicket.id;

      _this.$api.ticket
        .getTicketInfo({
          id: _this.ticketId,
          recruitId: _this.currentTicket.recruitId,
        })
        .then((response) => {
          _this.ticketInfo = response.data.content;
          if (response.data.version == "v1") {
            _this.printVisible = true;
          } else {
            _this.getPdfInfo(response.data.content);
            _this.printPdfVisible = true;
          }
          if (_this.currentTicket.printStatus == 0) {
            _this.updateTicketStatus(1);
          }
          this.dialogVisible = false;
        });
    },
    printTicket(ticket) {
      let _this = this;
      this.dialogVisible = true;
      _this.currentTicket = ticket;
      // _this.currentTicket = {
      //   id: 123,
      //   recruitId: 546
      // };
      _this.ticketShowInfo = {
        message:
          _this.currentTicket.recruitId == 461 ||
          _this.currentTicket.recruitId == 462
            ? "温馨提示：因考点周边道路施工，建议考生提前规划行程，预留充足时间，确保准时抵达考点。"
            : "温馨提示：请认真核对准考证信息",
        showImg:
          _this.currentTicket.recruitId == 546 ||
          _this.currentTicket.recruitId == 522,
      };
      return;
      _this.ticketId = ticket.id;

      _this.$layer.confirm(
        ticket.recruitId == 461 || ticket.recruitId == 462
          ? "温馨提示：因考点周边道路施工，建议考生提前规划行程，预留充足时间，确保准时抵达考点。"
          : "温馨提示：请认真核对准考证信息",
        {
          btn: ["确定"],
        },
        function (index) {
          _this.$api.ticket
            .getTicketInfo({ id: _this.ticketId, recruitId: ticket.recruitId })
            .then((response) => {
              _this.ticketInfo = response.data.content;
              if (response.data.version == "v1") {
                _this.printVisible = true;
              } else {
                _this.getPdfInfo(response.data.content);
                _this.printPdfVisible = true;
              }
              if (ticket.printStatus == 0) {
                _this.updateTicketStatus(1);
              }
            });
          _this.$layer.close(index);
        }
      );
    },
    updateTicketStatus(status) {
      let _this = this;
      _this.$api.ticket
        .updateTicketStatus({ id: _this.ticketId, printStatus: status })
        .then((response) => {});
    },
    getPdfInfo(strBase64) {
      try {
        this.src = "";
        this.pdfTotalPages = 0;
        let headers = {
          Authorization: this.$cookies.get(this.$commons.User.Authentication),
        };
        let datas = "data:application/pdf;base64," + strBase64;
        this.src = pdf.createLoadingTask({
          url: datas,
          // url: strBase64,
          httpHeaders: headers,
          CMapReaderFactory,
        });
        this.src.promise.then((pdf) => {
          this.pdfTotalPages = pdf.numPages;
        });
        // this.src = pdf.createLoadingTask({
        //   url: `${process.env.VUE_APP_BASE_API}/recruit/template/getPdfTemplate`,
        //   httpHeaders: headers,
        //   CMapReaderFactory,
        // });
      } catch (error) {
        this.$message({
          type: "error",
          message: "生成失败,请联系管理员",
          single: true,
        });
      }
    },
    printPdfObj() {
      this.$refs.pdfPrint.print();
      this.updateTicketStatus(2);
    },
    downloadFile() {
      let aLink = document.createElement("a");
      let blob = this.base64ToBlob(this.ticketInfo);
      let evt = document.createEvent("HTMLEvents");
      console.log("点击下载", evt);
      evt.initEvent("click", true, true);
      aLink.download = "考试准考证";
      aLink.href = URL.createObjectURL(blob);
      aLink.click();
    },
    // base64转blob
    base64ToBlob(code) {
      let raw = window.atob(code);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: "application/pdf" });
    },
  },
};
</script>
<style>
.tongguo {
  color: green !important;
}

.jujue {
  color: red !important;
}

.box {
  height: 600px;
  overflow-y: scroll;
}

.printMe {
  height: auto;
}

.printMe table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/mine/mineSign.vue